import {RequestMethod} from '@angular/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs/Rx';
import 'rxjs/Rx';
import {DayPilot} from 'daypilot-pro-angular';
import {CustomHttp} from "../common/http/custom.http";
import {RequestConfig, RestResponse} from "../shared/rest/rest.request";
import {PageImpl} from "../common/http/PageImpl";

@Injectable()
export class TurnosService {
    private GET_ALL_CODE = new RequestConfig("TUR", "application/json", true, RequestMethod.Get, "/work/shifts");
    private CREATE_CODE = new RequestConfig("TUR", "application/json", true, RequestMethod.Post, "/work/shifts");
    private EDIT_CODE = new RequestConfig("TUR", "application/json", true, RequestMethod.Put, "/work/shifts/{idWorkShift}");
    private DELETE_CODE = new RequestConfig("TUR", "application/json", true, RequestMethod.Delete, "/work/shifts/{idWorkShift}");
    private GET_CODE = new RequestConfig("TUR", "application/json", true, RequestMethod.Get, "/work/shifts/{idWorkShift}");
    private GET_PAGE = new RequestConfig("TUR", "application/json", true, RequestMethod.Get, "/work/shifts/page");

    bubble = new DayPilot.Bubble();
    events: any[] = [];

    constructor(private http: CustomHttp) {
    }

    /**
     * Envia una petición a WS para guardar turno
     */
    saveTurnos(turnosLaborales: TurnosLaborales): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_CODE, turnosLaborales)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de los turnos
     */
    getAll(): Observable<Array<TurnosLaborales>> {
        let workShifts: any = localStorage.getItem('workShifts');
        if (workShifts != undefined || workShifts != null) {
            let workShiftsParse = JSON.parse(workShifts)
            if (workShiftsParse != undefined) {
                let newData = new BehaviorSubject<any>(null);
                newData.next(workShiftsParse)
                return newData;
            }
        }
        else {
            return this.http.sendRequest(this.GET_ALL_CODE)
            .map((res: any) => {
                    try {
                        localStorage.setItem('workShifts', res._body);
                        return res.json();
                    } catch (e) {
                        return e => this.http.handleError(e);
                    }
                })
        };
    }

    /**
     * Envia petición a WS para obtener detalles de un turno
     */
    getTurno(idWorkShift: number): Observable<TurnosLaborales> {
        return this.http.sendRequest(this.GET_CODE, {}, idWorkShift)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envía petición a WS para editar datos de turno
     */
    updateTurnos(turnosLaborales: TurnosLaborales): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE, turnosLaborales, turnosLaborales.idWorkShift)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar datos de turno
     */
    deleteTurnos(idWorkShifts: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, idWorkShifts)
            .catch(error => this.http.handleError(error));
    }

    getEvents(from: DayPilot.Date, to: DayPilot.Date): Observable<any[]> {
        return new Observable(observer => {
            setTimeout(() => {
                observer.next(this.events);
            }, 200);
        });
    }

    getPage(options: any): Observable<PageImpl<TurnosLaborales>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
}

@Injectable()
export class TurnosLaborales {
    name: string;
    status: boolean;
    shiftHourViews: Array<ShiftHourViews>;
    idWorkShift: number;
}

@Injectable()
export class ShiftHourViews {
    startTime: string;
    endTime: string;
    day: number
}
